import { CIRCLE_IMAGE_URL, USER_IMAGE_URL } from "../config";
import moment from "moment";
import _ from "lodash";
import DEFAULT_CIRCLE_IMAGE from '../styles/images/no_circle_image.png'

export const paramsToQueryString = (params) => {
  if (params) {
    let query = '?'
    query += Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');
    return query;
  }
  return '';
}

export const convertNameToUrl = (suggestion) => {
  const suggestion_name = suggestion.name.toLowerCase();
  var split_name = suggestion_name.split(" ");
  return split_name.join("-");
};

export const getProductImageUrl = (product_photos) => {
  if (product_photos[0]) {
    return `${CIRCLE_IMAGE_URL}${product_photos[0]}`;
  } else if (product_photos[1]) {
    return `${CIRCLE_IMAGE_URL}${product_photos[1]}`;
  } else {
    return "https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg";
  }
};

export const getUserImageUrl = (user) => {
  return `${USER_IMAGE_URL}${user.profile_image}`;
};

export const getCircleDefaultImage = (callback) => {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      const image = reader.result;
      const base64_image_data = image.split(',')[1];
      callback(image, base64_image_data);
    }
    reader.readAsDataURL(xhr.response);
  };
  xhr.open('GET', DEFAULT_CIRCLE_IMAGE);
  xhr.responseType = 'blob';
  xhr.send();
}


export const generateDaysList = (start_date, number_of_days, last_date) => {
  let days = [];
  let current_date = moment(start_date);
  days.push(current_date);
  for (let i = 0; i < number_of_days; i++) {
    current_date = moment(current_date).add(1, "days");
    days.push(current_date);
    if (last_date && current_date.isSame(last_date, 'day')) {
      break;
    }
  }
  return days;
};

export const generateHoursList = (date, full_day, lastAllowedDateTime) => {
  const number_of_hours = full_day ? 49 : 48;
  let hours = [];
  const start_hour = moment(date).hour(0).minute(0);
  let currentTime = start_hour;
  hours.push(currentTime);

  var i = 1;
  while (i < number_of_hours) {
    currentTime = moment(currentTime).add(30, "minutes");
    if (lastAllowedDateTime && currentTime.isAfter(lastAllowedDateTime, 'minute')) {
      break;
    }
    hours.push(currentTime);
    i++;
  }

  return hours;
};

// this function takes an array of date ranges in this format:
// [{ start: Date, end: Date}]
// the array is first sorted, and then checked for any overlap
function areRangesOverlapping(dateRanges) {
  var sortedRanges = dateRanges.sort((previous, current) => {
    // get the start date from previous and current
    var previousTime = previous.start.getTime();
    var currentTime = current.start.getTime();

    // if the previous is earlier than the current
    if (previousTime < currentTime) {
      return -1;
    }

    // if the previous time is the same as the current time
    if (previousTime === currentTime) {
      return 0;
    }

    // if the previous time is later than the current time
    return 1;
  });

  var result = sortedRanges.reduce(
    (result, current, idx, arr) => {
      // get the previous range
      if (idx === 0) {
        return result;
      }
      var previous = arr[idx - 1];

      // check for any overlap
      var previousEnd = previous.end.getTime();
      var currentStart = current.start.getTime();
      var overlap = previousEnd > currentStart;

      // store the result
      if (overlap) {
        // yes, there is overlap
        result.overlap = true;
        // store the specific ranges that overlap
        result.ranges.push({
          previous: previous,
          current: current,
        });
      }

      return result;

      // seed the reduce
    },
    { overlap: false, ranges: [] }
  );

  // return the final results
  return result;
}
export function convertDateToUTC(date) {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
}
export const isBookingAllowed = (start_time, end_time, intervals) => {
  const start_datetime = start_time.toDate();
  const end_datetime = end_time.toDate();

  // if(end_time.hour()==0 && end_time.minute()==0){
  //   end_datetime = moment(end_time).add(1, 'day').toDate();
  // }

  if (start_datetime >= end_datetime) {
    return false;
  }

  let ranges_to_check = intervals.map((range) => {
    return {
      start: convertDateToUTC(new Date(range["start_time"])),
      end: convertDateToUTC(new Date(range["end_time"])),
    };
  });

  ranges_to_check.push({
    start: start_datetime,
    end: end_datetime,
  });
  return areRangesOverlapping(ranges_to_check)["overlap"] ? false : true;
};

export const sortArray = (numArray) => {
  return numArray.sort((a, b) => a.start - b.start); // For ascending sort
};

export const sortBookings = (numArray) => {   //TODO:create one function with parameter for object key
  return numArray.sort((a, b) => a.start_time - b.start_time); // For ascending sort
};


export const chunkArray = (myArray, chunk_size) => {
  var index = 0;
  var arrayLength = myArray.length;
  var tempArray = [];

  for (index = 0; index < arrayLength; index += chunk_size) {
    const myChunk = myArray.slice(index, index + chunk_size);
    tempArray.push(myChunk);
  }

  return tempArray;
};

export const validatePhoneNumber = (value, mandatory = false) => {
  if (!value || value.length === 0) {
    return mandatory ? "b2b.invalid_phone_number" : null;
  }
  const phoneNumberRegex = /^\+\d+/;
  const result = value.match(phoneNumberRegex);

  if (!result) {
    return "b2b.invalid_phone_number"
  }

  if (value.length > 0 && result[0] !== value) {
    return "b2b.invalid_phone_number"
  }

  if (value.length > 0 && value.length < 5) {
    return "b2b.invalid_phone_number"
  }

  if (value.length > 16) {
    return "b2b.invalid_phone_number"
  }
};

const CountriesAndPhones = [
  { country: "SE (+46)", value: "+46" },
  { country: "DK (+45)", value: "+45" },
  { country: "FI (+358)", value: "+358" },
  { country: "NO (+47)", value: "+47" },

  // { country: "US (+1)", value: "+1" },
  // { country: "RU (+7)", value: "+7" },
  // { country: "GB (+44)", value: "+44" },
  // { country: "IN (+91)", value: "+91" },
  // { country: "VN (+84)", value: "+84" },
  // { country: "RO (+40)", value: "+40" },
  // { country: "LT (+370)", value: "+370" },
  // { country: "EE (+372)", value: "+372" },
  // { country: "IS (+354)", value: "+354" },
  // { country: "NO (+47)", value: "+47" },
];

export const PhonePrefixes = _.orderBy(CountriesAndPhones, "value", "asc");
export const CountryPrefixes = _.orderBy(CountriesAndPhones, "country", "asc");